import { format } from "date-fns";

const detectDataType = (value) => {
    if (value === null || value === undefined) return "unknown";
    if (Array.isArray(value)) return "array";
    if (value instanceof Date) return "date";
    const type = typeof value;
    if (type === "string") {
        const datePattern = /^\d{4}-\d{2}-\d{2}/;
        if (datePattern.test(value) && !isNaN(Date.parse(value))) return "date";
        return "string";
    }
    return type;
};

const formatValueForSearch = (value, type) => {
    if (value == null) return "";
    switch (type) {
        case "date":
            const d = value instanceof Date ? value : new Date(value);
            return isNaN(d.getTime())
                ? String(value).toLowerCase()
                : format(d, "dd/MM/yy").toLowerCase();
        case "array":
            return value.join(" ").toLowerCase();
        case "object":
            return JSON.stringify(value).toLowerCase();
        default:
            return String(value).toLowerCase();
    }
};

const evaluateFilterRule = (value, rule, type) => {
    if (value == null) return false;
    const str = String(value).toLowerCase();
    const f = rule.value.toLowerCase();

    switch (rule.operator) {
        case "=":
            return str === f;
        case "!=":
            return str !== f;
        case ">":
            return type === "date"
                ? new Date(value) > new Date(rule.value)
                : Number(value) > Number(rule.value);
        case "<":
            return type === "date"
                ? new Date(value) < new Date(rule.value)
                : Number(value) < Number(rule.value);
        case "contains":
            return str.includes(f);
        case "startsWith":
            return str.startsWith(f);
        case "endsWith":
            return str.endsWith(f);
        default:
            return false;
    }
};

export const filterFlights = ({
    data,
    searchQuery,
    filters,
    columns,
}) => {
    let result = [...data];

    /** SEARCH */
    if (searchQuery.trim()) {
        const q = searchQuery.toLowerCase();
        result = result.filter(row =>
            columns.some(col => {
                if (!col.searchable || col.key === "__rowNumber") return false;
                const value = row[col.key];
                const type = col.type || detectDataType(value);
                return formatValueForSearch(value, type).includes(q);
            })
        );
    }

    /** ADVANCED FILTER */
    if (filters.rules.length) {
        result = result.filter(row => {
            const checks = filters.rules.map(rule => {
                const col = columns.find(c => c.key === rule.field);
                if (!col) return false;
                const value = row[rule.field];
                const type = col.type || detectDataType(value);
                return evaluateFilterRule(value, rule, type);
            });
            return filters.logicOperator === "AND"
                ? checks.every(Boolean)
                : checks.some(Boolean);
        });
    }

    return result;
};
